// extracted by mini-css-extract-plugin
module.exports = {"noActive":"Navbar_noActive__1Vyur","logoCOCanvas":"Navbar_logoCOCanvas__-K2Zr","offcanvas":"Navbar_offcanvas__3b5aG"};